module.exports = __webpack_public_path__ + "media/images/outlook-d0e8ea17c14312d5ea319fcd964fc3f1.svg";